import DiscussionSearch from "./components/DiscussionSearch";
import DiscussionSearchSource from "./components/DiscussionSearchSource";
import compat from "../common/compat";

export default {
  ...compat,
  'uikit/forum/DiscussionSearch': DiscussionSearch,
  'uikit/forum/DiscussionSearchSource': DiscussionSearchSource,
};
